import { useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { SignIn, VerificationCode } from 'modules/Auth'
import { AuthContext } from 'modules/Auth/context'

export function LoginRoute() {
  const { token, authData } = useContext(AuthContext)
  const location = useLocation()
  const from = (location.state as any)?.from?.pathname ?? '/'

  if (token) {
    return <Navigate to={from} replace />
  }

  if (authData) {
    return <VerificationCode />
  }

  return <SignIn />
}
